import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Sidebar from "./components/sidebar";
import Header from "./components/header";
import CloseButton from 'react-bootstrap/CloseButton';

const PatientRegistrationCsv = ({ role, token }) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [openSidebar, setOpenSidebar] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [registrationType, setRegistrationType] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        if (!role || !token) {
            navigate('/admin/login');
        } else if (role !== "dev") {
            setError("Unauthorized Access");
            setTimeout(() => navigate('/admin/login'), 3000);
        }
    }, [role, token, navigate]);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setError(null);
        setSuccess(null);
    };

    const handleRegistrationTypeChange = (event) => {
        setRegistrationType(event.target.value);
        setError(null);
        setSuccess(null);
    };

    const handleSubmit = () => {
        if (!registrationType) {
            setError("Please select a registration type (Normal or Custom)");
            return;
        }
        
        if (!selectedFile) {
            setError("Please select a file");
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(null);
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('registrationType', registrationType);
        formData.append('role', role);
        formData.append('token', token);

        // Use the same endpoint, pass registrationType parameter
        const endpoint = "/api/admin/registerPatientMRN";

        axios.post(endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                setLoading(false);
                console.log(typeof(res.data.results.errors.join('\n')))
                // setSuccess("File uploaded successfully");
                if(res.data.results.success.length > 0) {
                    setSuccess("File uploaded successfully", res.data.results.success);
                }
                if(res.data.results.errors.length > 0) {
                    console.log("test")
                    setError(res.data.results.errors);
                }
                console.log(error)
                setSelectedFile(null);
            })
            .catch(err => {
                setLoading(false);
                if (err.response) {
                    switch (err.response.status) {
                        case 401:
                            setError("Unauthorized: Please log in again");
                            setTimeout(() => navigate('/admin/login'), 3000);
                            break;
                        case 403:
                            setError("Forbidden: You don't have permission to perform this action");
                            break;
                        case 413:
                            setError("File too large: Please upload a smaller file");
                            break;
                        case 415:
                            setError("Unsupported file type: Please upload a .csv, .xlsx, or .xls file");
                            break;
                        case 500:
                            setError("Server error: Please try again later");
                            break;
                        default:
                            setError(err.response.data.error || "An error occurred");
                    }
                } else if (err.request) {
                    setError("Network error: Please check your internet connection");
                } else {
                    setError("An unexpected error occurred");
                }
            });
    };
    const handleClose = () => {
        setError(null);
        window.location.reload();
    }
    return (
        <div className="hcp-registration-layout" style={{ 
            height: '100vh', 
            display: 'flex',
            overflow: 'hidden'
        }}>
            <div className={`sidebar ${openSidebar ? 'open' : ''}`} style={{
                height: '100vh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 1000,
                transition: 'all 0.3s ease'
            }}>
                <Sidebar />
            </div>

            <main className={`main-content ${openSidebar ? 'sidebar-open' : ''}`} style={{ 
                minHeight: '100vh', 
                height: '100vh',
                display: 'flex', 
                flexDirection: 'column',
                flex: 1,
                marginLeft: openSidebar ? '20%' : '0',
                transition: 'margin-left 0.3s ease',
                overflow: 'auto'
            }}>
                <Header title="PATIENT REGISTRATION" openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />

                <div className="hcp-registration-upload" style={{ 
                    flex: 1,
                    height: '100%',
                    minHeight: 'calc(100vh - 80px)', // Subtract header height
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <h2>Upload Patient Registration File</h2>
                    {error && Array.isArray(error) && error.length > 0 ? (
                        <div className="message error">
                            <CloseButton onClick={handleClose} style={{'float': 'right'}}/>
                            <ul>
                                {error.map((error, index) => (
                                <li key={index}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    ) : error ? (
                        <div className="message error">{error}</div>
                    ) : null}
                    {success && (
                        <div className="message success">{success}</div>
                    )}
                    
                    {/* Beautiful Registration Type Selection */}
                    <div style={{
                        backgroundColor: '#f8f9fa',
                        border: '2px solid #e3f2fd',
                        borderRadius: '12px',
                        padding: '24px',
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                        <h3 style={{
                            margin: '0 0 16px 0',
                            color: '#1976d2',
                            fontSize: '18px',
                            fontWeight: '600'
                        }}>
                            📋 Step 1: Select Registration Type
                        </h3>
                        <select
                            id="registration-type"
                            value={registrationType}
                            onChange={handleRegistrationTypeChange}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                fontSize: '16px',
                                border: '2px solid #ddd',
                                borderRadius: '8px',
                                backgroundColor: 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                outline: 'none'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                            onBlur={(e) => e.target.style.borderColor = '#ddd'}
                        >
                            <option value="" disabled hidden>Select Registration Type</option>
                            <option value="Normal">✅ Normal Registration</option>
                            <option value="Custom">⚡ Custom Registration</option>
                        </select>
                    </div>

                    {/* Beautiful File Upload Section */}
                    <div style={{
                        backgroundColor: registrationType ? '#f1f8e9' : '#f5f5f5',
                        border: `2px solid ${registrationType ? '#4caf50' : '#ccc'}`,
                        borderRadius: '12px',
                        padding: '24px',
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        opacity: registrationType ? 1 : 0.6,
                        transition: 'all 0.3s ease'
                    }}>
                        <h3 style={{
                            margin: '0 0 16px 0',
                            color: registrationType ? '#388e3c' : '#666',
                            fontSize: '18px',
                            fontWeight: '600'
                        }}>
                            📁 Step 2: Choose Your File
                        </h3>
                        <label 
                            htmlFor="file-upload" 
                            style={{
                                display: 'inline-block',
                                padding: '16px 32px',
                                border: '2px solid #4caf50',
                                borderRadius: '8px',
                                backgroundColor: registrationType ? '#4caf50' : '#ccc',
                                color: 'white',
                                textAlign: 'center',
                                cursor: registrationType ? 'pointer' : 'not-allowed',
                                transition: 'all 0.3s ease',
                                fontSize: '16px',
                                fontWeight: '600',
                                boxShadow: registrationType ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none',
                                userSelect: 'none'
                            }}
                            onMouseEnter={(e) => {
                                if (registrationType) {
                                    e.target.style.backgroundColor = '#388e3c';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (registrationType) {
                                    e.target.style.backgroundColor = '#4caf50';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 8px rgba(76, 175, 80, 0.3)';
                                }
                            }}
                        >
                            <input
                                id="file-upload"
                                type="file"
                                onChange={handleFileChange}
                                accept=".csv"
                                disabled={!registrationType}
                                style={{ display: 'none' }}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                {selectedFile ? (
                                    <>
                                        <span>📄</span>
                                        <span>{selectedFile.name}</span>
                                    </>
                                ) : (
                                    <>
                                        <span>📁</span>
                                        <span>Choose CSV File</span>
                                    </>
                                )}
                            </div>
                        </label>
                        
                        {selectedFile && (
                            <div style={{ 
                                marginTop: '12px', 
                                padding: '12px', 
                                backgroundColor: '#e8f5e8', 
                                borderRadius: '6px',
                                border: '1px solid #4caf50',
                                textAlign: 'center'
                            }}>
                                <div style={{ color: '#2e7d32', fontSize: '14px' }}>
                                    ✅ File selected: <strong>{selectedFile.name}</strong>
                                </div>
                                <div style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>
                                    Click the button again to change file
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Beautiful Submit Button */}
                    <button
                        onClick={handleSubmit}
                        disabled={!registrationType || !selectedFile || loading}
                        style={{
                            width: '100%',
                            padding: '16px 24px',
                            fontSize: '18px',
                            fontWeight: '600',
                            border: '2px solid transparent',
                            borderRadius: '8px',
                            backgroundColor: (!registrationType || !selectedFile || loading) ? '#e0e0e0' : '#1976d2',
                            color: (!registrationType || !selectedFile || loading) ? '#888' : 'white',
                            cursor: (!registrationType || !selectedFile || loading) ? 'not-allowed' : 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: (!registrationType || !selectedFile || loading) ? 'none' : '0 4px 12px rgba(25,118,210,0.3)',
                            transform: loading ? 'scale(0.98)' : 'scale(1)',
                            opacity: (!registrationType || !selectedFile || loading) ? 0.6 : 1
                        }}
                        onMouseEnter={(e) => {
                            if (!e.target.disabled) {
                                e.target.style.backgroundColor = '#1565c0';
                                e.target.style.transform = 'scale(1.02)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!e.target.disabled) {
                                e.target.style.backgroundColor = '#1976d2';
                                e.target.style.transform = 'scale(1)';
                            }
                        }}
                    >
                        {loading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <div style={{
                                    width: '20px',
                                    height: '20px',
                                    border: '2px solid #888',
                                    borderTop: '2px solid transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite'
                                }}></div>
                                Uploading...
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                {(!registrationType || !selectedFile) ? (
                                    <>⚠️ Please complete all steps</>
                                ) : (
                                    <>🚀 Submit Registration</>
                                )}
                            </div>
                        )}
                    </button>

                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                    
                    <div>
                        <div style={{'margin': '10px auto', 'textAlign': 'center'}}>
                            <h7>Medication Details</h7>
                            <table>
                                <tr>
                                    <th>Brand</th>
                                    <th>Medication</th>
                                    <th>SKU</th>
                                </tr>
                                <tr>
                                    <td>Adaxil Sachets</td>
                                    <td>750 mg/600 mg</td>
                                    <td>MN400561123AC</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>5/40 mg</td>
                                    <td>379400565236</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>10/20 mg</td>
                                    <td>379400564926</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>5/20 mg</td>
                                    <td>379400564925</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>5/10 mg</td>
                                    <td>379400564923</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>10/40 mg</td>
                                    <td>379400565235</td>
                                </tr>
                                <tr>
                                    <td>Caduet</td>
                                    <td>10/10 mg</td>
                                    <td>379400564924</td>
                                </tr>
                                <tr>
                                    <td>Celebrex Capsules</td>
                                    <td>200 mg</td>
                                    <td>400570436</td>
                                </tr>
                                <tr>
                                    <td>Inspra Capsules</td>
                                    <td>25 mg</td>
                                    <td>400562897pp</td>
                                </tr>
                                <tr>
                                    <td>Inspra Capsules</td>
                                    <td>50 mg</td>
                                    <td>400565341pp</td>
                                </tr>
                                <tr>
                                    <td>Legalon</td>
                                    <td>140 mg</td>
                                    <td>MN400560297AC</td>
                                </tr>
                                <tr>
                                    <td>Lipitor</td>
                                    <td>20 mg</td>
                                    <td>379400566617</td>
                                </tr>
                                <tr>
                                    <td>Lipitor</td>
                                    <td>80 mg</td>
                                    <td>379400566619</td>
                                </tr>
                                <tr>
                                    <td>Lipitor</td>
                                    <td>10 mg</td>
                                    <td>379400566616</td>
                                </tr>
                                <tr>
                                    <td>Lipitor</td>
                                    <td>40 mg</td>
                                    <td>379400566618</td>
                                </tr>
                                <tr>
                                    <td>Lyrica Capsules</td>
                                    <td>50 mg</td>
                                    <td>400564954</td>
                                </tr>
                                <tr>
                                    <td>Lyrica Capsules</td>
                                    <td>75 mg</td>
                                    <td>400564955</td>
                                </tr>
                                <tr>
                                    <td>Lyrica Tablets</td>
                                    <td>82.5 mg</td>
                                    <td>400564956</td>
                                </tr>
                                <tr>
                                    <td>Lyrica Tablets</td>
                                    <td>165 mg</td>
                                    <td>400564957</td>
                                </tr>
                                <tr>
                                    <td>Norvasc</td>
                                    <td>5 mg</td>
                                    <td>379400563819</td>
                                </tr>
                                <tr>
                                    <td>Norvasc</td>
                                    <td>10 mg</td>
                                    <td>379400563818</td>
                                </tr>
                                <tr>
                                    <td>Viartril-S Capsules</td>
                                    <td>500 mg</td>
                                    <td>MN400558585AC</td>
                                </tr>
                                <tr>
                                    <td>Viartril-S Capsules 750</td>
                                    <td>750 mg</td>
                                    <td>400564958</td>
                                </tr>
                                <tr>
                                    <td>Viagra</td>
                                    <td>100 mg</td>
                                    <td>379400562860</td>
                                </tr>
                            </table>
                        </div>
                    
                    </div>
                </div>
            </main>

            <style jsx>{`
                .hcp-registration-layout {
                    display: flex;
                    height: 100vh;
                }

                .sidebar {
                    width: 20%;
                    background-color: #FE7072;
                    transition: margin-left 0.3s;
                }

                .sidebar.open {
                    margin-left: 0;
                }

                .main-content {
                    flex-grow: 1;
                    padding: 20px;
                    transition: margin-left 0.3s;
                }

                .main-content.sidebar-open {
                    margin-left: 0%;
                }

                .hcp-registration-upload {
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    margin-top: 20px;
                }

                .hcp-registration-upload h2 {
                    font-size: 24px;
                    margin-bottom: 20px;
                }

                .message {
                    padding: 10px;
                    border-radius: 4px;
                    margin-bottom: 15px;
                }

                .message.error {
                    background-color: #ffebee;
                    color: #c62828;
                    border: 1px solid #ef9a9a;
                }

                .message.success {
                    background-color: #e8f5e9;
                    color: #2e7d32;
                    border: 1px solid #a5d6a7;
                }

                .file-upload-area {
                    margin-bottom: 20px;
                }

                .file-upload-label {
                    display: inline-block;
                    padding: 10px 15px;
                    background-color: #f0f0f0;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                }

                .file-upload-label input {
                    display: none;
                }

                .submit-button {
                    display: block;
                    width: 100%;
                    padding: 10px;
                    background-color: #0c0f69;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                }

                .submit-button:disabled {
                    background-color: #cccccc;
                    cursor: not-allowed;
                }

                .submit-button.loading {
                    opacity: 0.7;
                }
                table {
                    width: 80%;
                    margin: 10px auto;
                    border-collapse: collapse;
                    font-size: 12px;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
                }
                th, td {
                    border: 1px solid #cfc1c1;
                    padding: 2px;
                    text-align: center;
                }
                th {
                    background-color: #ddd;
                    color: black;
                }
                tr:nth-child(even) {
                    background-color: #f2f2f2;
                }
                tr:hover {
                    background-color: #ddd;
                }
                caption {
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .close-btn {
                    display: block;
                    margin: 20px auto;
                    padding: 8px 16px;
                    background-color: #ff4d4d;
                    color: white;
                    border: none;
                    border-radius: 5px;
                    font-size: 14px;
                    cursor: pointer;
                    text-align: center;
                }
                .close-btn:hover {
                    background-color: #ff1a1a;
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        token: state.admin.token,
        role: state.admin.role
    };
};

export default connect(mapStateToProps, null)(PatientRegistrationCsv);